/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React, { useState } from 'react';
import { useTheme } from '@/providers/theme';
import { Col, Row, Card, Button, Image } from 'react-bootstrap';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { useNavigate, useLocation } from 'react-router-dom';

import { Header, BackArrowComp, getWidgetData } from '../components';
import { vappContainer, VApplication } from '@/application';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { StatusTimelinePageService } from '../services';
import { TweetyWidget } from '@/widgets/tweety-widget-react-main';
import { TimelineMercury } from '@vlinder-web/timeline-mercury-widget-react';
import { useSMStatusTimeLinePage } from '../machines';
import { ItemSpecVenusWidget } from '@/widgets/item-spec-venus-widget-react';
import { Loader } from '@/components';
const getSrv = () => {
  return vappContainer.get<StatusTimelinePageService>(
    StatusTimelinePageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const { statusTimeLinePageSend, statusTimeLinePageState } =
    useSMStatusTimeLinePage({});
  const [isProfileExist, setIsProfileExist] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const staticPageContentConfig = getSrv()?.agent.getStaticPageContentSync();
  const history = useNavigate();
  const location = useLocation();
  const srv = getSrv();
  console.log(statusTimeLinePageState?.event?.data?.value, 'l-->');

  const onRefresh = () => {
    statusTimeLinePageSend('TRIGGER_REFRESH', {});
  };

  const renderTimeLine = () => {
    if (statusTimeLinePageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.loadingProfile || {})} />
      );
    }
    if (statusTimeLinePageState?.matches('RENDER_PAGE')) {
      console.log('STATE DATA :', location);
      console.log(
        'timelinedata->',
        statusTimeLinePageState?.event?.data?.value?.data.slice().reverse()
      );
      return (
        <>
          {/* @ts-ignore */}
          <ItemSpecVenusWidget
            {...getWidgetData(location?.state)}
            onListClick={(item: any) => console.log(`item clicked`, item)}
            onPageChange={(event: any) => console.log(`page change`, event)}
            onSubmit={() => {}}
            onTerminate={() => {}}
            onActionClick={(key, listId) =>
              console.log(`on action click`, key, listId)
            }
            // onItemClick={()=>{}}
          />
          <TimelineMercury
            items={statusTimeLinePageState?.event?.data?.value?.data}
            onItemClick={(itemId: string) => {}}
          />
        </>
      );
    }
  };
  const _renderErrorModals = () => {
    if (statusTimeLinePageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getProfile || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };

  const _renderHeader = () => {
    // return <BackArrowComp />
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header
            backButton={true}
            onBackClick={() => history(-1)}
            {...(staticPageContentConfig?.header || {})}
            onRefreshClick={onRefresh}
          />
        </>
      );
    }
    return null;
  };

  return (
    <>
      {_renderHeader()}
      {renderTimeLine()}
      {_renderErrorModals()}
    </>
  );
};
